<template>
  <div>
    <v-card style="font-size: 0.8rem;">
      <v-card-text>
        <!--必须要有产品配置，默认那第一个-->
        <div class="row" v-if="configId">
          <div class="col-xl-12">
            <div class="row border-bottom alert-success">
              <div class="col-xl-12">
                <span class="font-weight-bolder font-size-lg">{{$t('PRICE.PRODUCT')}}&nbsp;&nbsp;&nbsp;</span>
                <a href="javascript:;" v-on:click="showOrderAgreement">
                  <span class="font-weight-bolder font-size-lg text-primary">({{$t('PRICE.Order_agreement')}})</span>
                </a>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-xl-12 border-bottom">
                <div class="text-muted"><span class="text-danger">*</span>{{$t('ONLINE.Product_Type')}}</div>
                <template v-for="craft in mainConfigList">
                  <div :key="craft.recordId" class="pt-3">
                    <button type="button" :class="craft.checked == 1? 'btn btn-sm btn-outline-primary text-left':
                  'btn btn-sm btn-outline-secondary text-left'" v-on:click="getConfigList(craft.recordId)">
                      {{ craft.name }}
                    </button>
                  </div>
                </template>
              </div>
              <div class="col-xl-2 border-bottom">
                <div class="text-muted"><span class="text-danger">*</span>PCS{{$t('ONLINE.SIZE')}}(mm)</div>
                <div class="input-group">
                  <input class="form-control form-control-sm" :placeholder="$t('ONLINE.LENGTH')" v-model="unitLength" v-on:blur="this.getDeliveryTime">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-secondary">*</button>
                  </div>
                  <input class="form-control form-control-sm" :placeholder="$t('ONLINE.WIDTH')" v-model="unitWidth" v-on:blur="this.getDeliveryTime">
                </div>
              </div>
              <div class="col-xl-4 border-bottom">
                <div class="text-muted"><span class="text-danger">*</span>{{$t('ONLINE.Specification_Size')}}(mm)</div>
                <div class="input-group">
                  <input class="form-control form-control-sm" :placeholder="$t('ONLINE.LENGTH')" v-model="pnlLength" v-on:blur="this.getDeliveryTime">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-secondary">*</button>
                  </div>
                  <input class="form-control form-control-sm" :placeholder="$t('ONLINE.WIDTH')" v-model="pnlWidth" v-on:blur="this.getDeliveryTime">
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-outline-secondary">/</button>
                  </div>
                  <input class="form-control form-control-sm" :placeholder="$t('ONLINE.Concatenation_Number')" v-model="pnlDivisor" v-on:blur="this.getDeliveryTime">
                </div>
              </div>
              <div class="col-xl-2 border-bottom">
                <div class="text-muted"><span class="text-danger">*</span>{{$t('ONLINE.QUANTITY')}}(pcs)</div>
                <input class="form-control form-control-sm" v-model="quantity" v-on:blur="this.getDeliveryTime">
              </div>
              <div class="col-xl-2 border-bottom">
                <div class="text-muted"><span class="text-danger">*</span>{{$t('ONLINE.Order_Type')}}</div>
                <select class="form-control form-control-sm" v-model="materialType" v-on:change="this.getDeliveryTime">
                  <option value="2">{{$t('ONLINE.New_Order')}}</option>
                  <option value="3">{{$t('ONLINE.REORDER')}}</option>
                </select>
              </div>
              <div class="col-xl-2 border-bottom">
                <div class="text-muted"><span class="text-danger">*</span>{{$t('ONLINE.Currency_Type')}}</div>
                <select class="form-control form-control-sm" v-model="currencyType" v-on:change="loadExchangeRate">
                  <template v-for="item in currencyTypeList">
                    <option :key="item.recordId" :value="item.recordId">{{item.value}}</option>
                  </template>
                </select>
              </div>
            </div>
            <!--第一层，菜单层-->
            <template v-for="item in configList">
              <!--disableFlag: 1:可编辑，2:不可编辑，3:隐藏，selectFlag：触发显示条件-->
              <div class="row" :key="item.recordId" v-if="item.disableFlag != 3 || item.selectFlag">
                <div class="col-xl-12 alert-primary">
                  <span class="font-weight-bolder font-size-lg">{{item.name}}</span>
                </div>
                <!--第一层，单据层-->
                <template v-for="(row,index) in item.list">
                  <div :key="row.recordId" :class="getColWidth(row.rowFlag)" v-if="row.disableFlag != 3 || row.selectFlag">
                    <div class="row align-items-center border-bottom">
                      <div class="col-xl-12">
                        <div class="row">
                          <div :class="row.inputWidth ? row.inputWidth : 'col-xl-12' + ' p-2'">
                            <div class="text-muted pb-1" :id="'row'+index">
                              {{row.name}}<span v-if="row.prompt">({{row.prompt}})</span>
                            </div>
                            <div class="input-group" v-if="row.inputType == 1">
                              <input class="form-control form-control-sm" v-model="row.value" :disabled="row.disableFlag == 2">
                              <div class="input-group-append" v-if="row.unitType">
                                <button class="btn btn-sm btn-outline-secondary">{{row.unitType}}</button>
                              </div>
                            </div>
                            <div class="input-group" v-if="row.inputType == 2">
                              <input class="form-control form-control-sm" :placeholder="$t('ONLINE.LENGTH')" v-model="row.value1">
                              <div class="input-group-append">
                                <button class="btn btn-sm btn-outline-secondary">*</button>
                              </div>
                              <input class="form-control form-control-sm" :placeholder="$t('ONLINE.WIDTH')" v-model="row.value2">
                              <div class="input-group-append" v-if="row.unitType">
                                <button class="btn btn-sm btn-outline-secondary">{{row.unitType}}</button>
                              </div>
                            </div>
                            <div class="input-group" v-if="row.inputType == 3">
                              <input class="form-control form-control-sm" :placeholder="$t('ONLINE.LENGTH')" v-model="row.value1">
                              <div class="input-group-append">
                                <button class="btn btn-sm btn-outline-secondary">*</button>
                              </div>
                              <input class="form-control form-control-sm" :placeholder="$t('ONLINE.WIDTH')" v-model="row.value2">
                              <div class="input-group-append">
                                <button class="btn btn-sm btn-outline-secondary">/</button>
                              </div>
                              <input class="form-control form-control-sm" :placeholder="$t('ONLINE.Concatenation_Number')" v-model="row.value3">
                              <div class="input-group-append" v-if="row.unitType">
                                <button class="btn btn-sm btn-outline-secondary">{{row.unitType}}</button>
                              </div>
                            </div>
                            <!--selectType:验证是否触发显示隐藏内容条件-->
                            <div v-if="row.inputType == 4">
                              <template v-for="craft in row.list">
                                <button type="button" :class="craft.checked == 1?
                                 'btn btn-sm btn-outline-primary py-1': 'btn btn-sm btn-outline-secondary py-1'"
                                        :key="craft.recordId" :disabled="craft.disableFlag == 2"
                                        v-on:click="selectType(craft, row,item.list,item)">
                                  {{ craft.value }}
                                </button>&nbsp;
                              </template>
                            </div>
                            <div v-if="row.inputType == 5">
                              <template v-for="craft in row.list">
                                <button type="button" :class="craft.checked == 1? 'btn btn-sm btn-outline-primary py-1': 'btn btn-sm btn-outline-secondary py-1'"
                                        :key="craft.recordId" :disabled="craft.disableFlag == 2"
                                        v-on:click="selectType(craft, row,item.list,item)">
                                  {{ craft.value }}
                                </button>&nbsp;
                              </template>
                            </div>
                            <div v-if="row.inputType == 7">
                              <textarea class="form-control form-control-sm" v-model="row.value" :disabled="row.disableFlag == 2"></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
        <div class="row pb-7">
          <div class="col-xl-12 text-right">
            <button class="btn btn-primary" v-if="orderNowFlag" v-on:click="saveDeail(0)">
              {{$t('PRICE.OrderTwo')}}
            </button>
            <button class="btn btn-primary" v-else  v-on:click="getBrandList">
              {{$t('PRICE.Order')}}
            </button>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <b-modal ref="tipWindow" hide-footer size="xl">
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('PRICE.Select_material_brand')}}</h5>
        <!-- Emulate built in modal header close button action -->
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row align-items-center border-bottom">
        <label class="col-xl-6 p-2 font-weight-bolder">{{$t('ONLINE.Upload_attachments')}}</label>
        <div class="col-xl-6 p-2 text-right">
          <button class="btn btn-sm btn-primary">{{$t('ONLINE.Computer_upload')}}</button>
          <a href="javascript:;" class="fileUp">
            <input id="file" type="file" v-on:change="uploadMaterials" multiple="multiple"/>
          </a>
        </div>
      </div>
      <template v-for="(item,index) in fileList">
        <div class="row align-items-center border-bottom" :key="index">
          <div class="col-xl-8 p-2 text-primary">
            {{item.name}}
          </div>
          <div class="col-xl-4 p-2 text-right">
            <button type="button" class="btn btn-sm btn-danger px-1 py-1" v-on:click="delAttachment(index)">{{$t('ONLINE.delete')}}</button>&emsp;
            <button type="button" class="btn btn-sm btn-success px-1 py-1" v-on:click="showPreview(item)">{{$t('ONLINE.Preview')}}</button>
          </div>
        </div>
      </template>
      <div class="row border-bottom">
        <div class="col-xl-12 p-2 font-weight-bolder">
          {{$t('PRICE.Select_material_brand')}}
        </div>
        <div class="col-xl-12 p-2">
          <template v-for="craft in materiaDatalListStr">
            <button type="button" :key="craft.recordId" :class="craft.value == brand? 'btn btn-sm btn-outline-primary py-1':
              'btn btn-sm btn-outline-secondary py-1'" v-on:click="selectBond(craft.value)">
              {{ craft.showValue}}
            </button>&nbsp;
          </template>
          <template v-if="!materiaDatalListStr || materiaDatalListStr.length == 0 || (brand && (!avgPrice || avgPrice == 0))">
            <span style="color: red">{{$t('PRICE.Material_fee_and_other_background_confirmation')}}</span>
          </template>
        </div>
      </div>
      <div class="row border-bottom">
        <div class="col-xl-12 p-2 font-weight-bolder">
          {{$t('ONLINE.Process_Validation')}}
        </div>
        <div class="col-xl-12 p-2 text-primary">
          <template v-for="item in configList">
            <span :key="item.recordId">
              <template v-for="row in item.list">
                <span :key="row.recordId" v-if="row.value || row.checked">
                  <span v-if="row.inputType == 1 || row.inputType == 7">{{row.value}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 2">{{row.value1}}*{{row.value2}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 3">{{row.value1}}*{{row.value2}}/{{row.value3}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 4 || row.inputType == 5">
                    <template v-for="craft in row.list"><span :key="craft.recordId" v-if="craft.checked == 1">{{ craft.value }}&nbsp;&nbsp;&nbsp;</span></template>
                  </span>
                </span>
              </template>
            </span>
          </template>
        </div>
      </div>
      <v-row class="border-bottom" v-if="false">
        <v-col lg="12" class="p-2">
          <div class="font-weight-bolder font-size-lg pb-3">
            {{$t('ONLINE.Quotation_details')}}<span class="text-danger">(只用于测试对比价格，正式版隐藏)</span>
          </div>
          <table class="table table-bordered text-center" style="padding-top: 0px;padding-bottom: 0px;">
            <tbody v-for="(row, recordId) in setUpList" :key="recordId">
            <tr v-for="item in row.list" :key="item.recordId">
              <td v-if="item.useFlag">
                <div class="row align-items-center" style="font-size: 0.5rem; text-align: left;">
                  <div class="col-md-4 border-right" :title="row.itemName">
                    {{row.name}}:
                    <span v-for="itemRow in item.list" :key="itemRow.recordId" style="text-align: left">
                          <span v-if="itemRow.type == 1">
                          <span v-if="itemRow.columnCondition == 1">{{itemRow.itemName}}＝{{itemRow.columnValVal}}</span>
                          <span v-if="itemRow.columnCondition == 2">{{itemRow.itemName}}≠{{itemRow.columnValVal}}</span>

                          <span v-if="itemRow.columnCondition == 4">{{itemRow.columnValVal}}＜{{itemRow.itemName}}</span>
                          <span v-if="itemRow.columnCondition == 6">{{itemRow.columnValVal}}≤{{itemRow.itemName}}</span>
                          <span v-if="itemRow.columnConditionTwo == 6">{{itemRow.columnValTwo}}≤</span>
                          <span v-if="itemRow.columnConditionTwo == 4">{{itemRow.columnValTwo}}＜</span>

                          <span v-if="itemRow.columnConditionTwo == 3">＜{{itemRow.columnValTwo}}</span>
                          <span v-if="itemRow.columnConditionTwo == 5">≤{{itemRow.columnValTwo}}</span>
                          <span v-if="itemRow.columnCondition == 3">{{itemRow.itemName}}＜{{itemRow.columnValVal}}</span>
                          <span v-if="itemRow.columnCondition == 5">{{itemRow.itemName}}≤{{itemRow.columnValVal}}</span>
                        </span>
                        <span v-if="itemRow.type == 2" style="text-align: left">
                          <span v-if="itemRow.columnCondition == 1">{{itemRow.itemName}}＝</span>
                          <span v-if="itemRow.columnCondition == 2">{{itemRow.itemName}}≠</span>
                          <span v-if="itemRow.columnCondition == 3">{{itemRow.itemName}}包含</span>
                          <span v-if="itemRow.columnCondition == 4">{{itemRow.itemName}}不包含</span>{{itemRow.columnValVal}}
                        </span>
                      </span>
                  </div>
                  <div class="col-md text-right border-secondary border-right p-1">
                    单价:￥ {{item.price}}
                    <span v-if="row.countMethod == 1">元/㎡</span>
                    <span v-if="row.countMethod == 2">元/PCS</span>
                    <span v-if="row.countMethod == 3">元/孔</span>
                    <span v-if="row.countMethod == 4">元</span>
                  </div>
                  <div class="col-md text-right">金额:￥{{item.countMoney}} 元</div>
                </div>
              </td>
            </tr>
            </tbody>
            <tr v-if="avgPrice && avgPrice > 0">
              <td>
                <div class="row align-items-center" style="font-size: 0.5rem;">
                  <div class="col-md-4 border-right" style="text-align: left;">
                    材料费：
                  </div>
                  <div class="col-md text-right border-secondary border-right p-1">
                    单价:￥ {{avgPrice}}元/㎡&nbsp;利用率:{{useRatio}}% &nbsp;管理费:{{managePrecent}}% &nbsp;业务费率：0%
                  </div>
                  <div class="col-md text-right">金额:￥{{materialFee.toFixed(2)}} 元</div>
                </div>
              </td>
            </tr>
            <tr v-if="rate && rate > 0">
              <td>
                <div class="row align-items-center" style="font-size: 0.5rem;">
                  <div class="col-md-4 border-right" style="text-align: left">
                    额外费用：
                  </div>
                  <div class="col-md text-right border-secondary border-right p-1">
                    费率:{{rate}}%
                  </div>
                  <div class="col-md text-right">金额:￥{{rateSubtotal.toFixed(2)}} 元</div>
                </div>
              </td>
            </tr>
            <tr v-if="amount && amount > 0">
              <td>
                <div class="row align-items-center" style="font-size: 0.5rem;">
                  <div class="col-md-4 border-right" style="text-align: left;">
                    总费用：
                  </div>
                  <div class="col-md text-right border-secondary border-right p-1">
                    平米单价:￥ {{(amount / orderDeailArea).toFixed(4) }}元
                  </div>
                  <div class="col-md text-right">金额:￥{{amount}} 元</div>
                </div>
              </td>
            </tr>
            <tr v-if="amount && amount > 0">
              <td>
                <div class="row align-items-center" style="font-size: 0.5rem;">
                  <div class="col-md-4 border-right" style="text-align: left;">
                    总费用：
                  </div>
                  <div class="col-md text-right border-secondary border-right p-1">
                    单价:￥ {{price}}元
                  </div>
                  <div class="col-md text-right">金额:￥{{amount}} 元</div>
                </div>
              </td>
            </tr>
            <tbody>
            </tbody>
          </table>
        </v-col>
      </v-row>
      <div class="row align-items-center border-bottom">
        <div class="col-xl-12 p-2 font-weight-bolder">
          {{$t('PRICE.Order_delivery_date')}}
        </div>
        <div class="col-xl-6 p-2">
          {{$t('PRICE.Order_date')}}
        </div>
        <div class="col-xl-6 p-2 text-right">
          {{currDate}}
        </div>
        <div class="col-xl-6 p-2">
          {{$t('PRICE.Estimated_delivery')}}
        </div>
        <div class="col-xl-6 p-2 text-right">
          {{estimateDate}}
        </div>
      </div>
      <div class="row align-items-center border-bottom">
        <div class="col-xl-12 p-2 font-weight-bolder">
          {{$t('PRICE.Estimated_price')}}
        </div>
        <div class="col-xl-6 p-2">
          {{$t('PRICE.Exchange_rate')}}
        </div>
        <div class="col-xl-6 p-2 text-right">
          {{exchangeRate}}
        </div>
        <div class="col-xl-6 p-2">
          {{$t('PRICECONENT.Price')}}(PCS)
          <span v-if="exchangeType == 'USD'">(dollar)</span>
          <span v-if="exchangeType == 'HKD'">(Hong Kong)</span>
          <span v-if="!exchangeType">({{$t('ONLINE.RMB')}})</span>:&nbsp;
          <span v-if="exchangeType == 'USD'">$</span>
          <span v-if="exchangeType == 'HKD'">HK$</span>
          <span v-if="!exchangeType">￥</span>
          <span v-if="exchangeRate">{{(price / exchangeRate).toFixed(4)}}</span>
          <span v-else>{{price}}</span>
        </div>
        <div class="col-xl-6 p-2 text-right">
          {{$t('ONLINE.QUANTITY')}}:&nbsp;{{quantity}}PCS
        </div>
        <div class="col-xl-6 p-2">
          {{$t('PRICECONENT.Price')}}(㎡)
          <span v-if="exchangeType == 'USD'">(dollar)</span>
          <span v-if="exchangeType == 'HKD'">(Hong Kong)</span>
          <span v-if="!exchangeType">({{$t('ONLINE.RMB')}})</span>:&nbsp;
          <span v-if="exchangeType == 'USD'">$</span>
          <span v-if="exchangeType == 'HKD'">HK$</span>
          <span v-if="!exchangeType">￥</span>
          <span v-if="exchangeRate">{{(amount / orderDeailArea / exchangeRate).toFixed(4)}}</span>
          <span v-else>{{(amount / orderDeailArea).toFixed(4) }}</span>
        </div>
        <div class="col-xl-6 p-2 text-right">
          {{$t('PRICE.Area')}}:&nbsp;{{orderDeailArea}}㎡
        </div>
        <div class="col-xl-6 p-2">
          {{$t('PRICE.Total_amount')}}
          <span v-if="exchangeType == 'USD'">(dollar)</span>
          <span v-if="exchangeType == 'HKD'">(Hong Kong)</span>
          <span v-if="!exchangeType">({{$t('ONLINE.RMB')}})</span>
        </div>
        <div class="col-xl-6 p-2 text-right">
          <span v-if="exchangeType == 'USD'">$</span>
          <span v-if="exchangeType == 'HKD'">HK$</span>
          <span v-if="!exchangeType">￥</span>
          <span v-if="exchangeRate">{{(amount / exchangeRate).toFixed(2)}}</span>
          <span v-else>{{amount}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 text-right">
          <button class="btn btn-primary" v-if="estimateDate && estimateDate != ''" v-on:click="saveDeail(0)">{{$t('PRICE.OrderTwo')}}</button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="orderAgreementOpen" hide-footer size="xl">
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('PRICE.Order_agreement')}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <v-row>
        <v-col cols="12">
          <template v-for="item in orderAgreementList">
            <div :key="item.recordId" v-html="item.content"></div>
          </template>
        </v-col>
      </v-row>
    </b-modal>
    <b-modal ref="previewId" hide-footer size="xl">
      <template v-slot:modal-header="{ close }">
        <h5></h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row">
        <div class="col-xl-12">
          <img id="preview" src="" class="w-100">
        </div>
      </div>
    </b-modal>
    <b-modal ref="fileMessage" hide-footer>
      <template v-slot:modal-header="{ close }">
        <h5></h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row border-bottom text-danger">
        <div class="col-xl-12 font-size-lg font-weight-bolder">
          {{$t('CONTENT.No_attachment_selected')}}
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 text-right">
          <button class="btn btn-sm btn-primary" v-on:click="closeFile">{{$t('ONLINE.Upload_attachment')}}</button>&nbsp;
          <button class="btn btn-sm btn-danger" v-on:click="saveDeail(1)">{{$t('ORDER.confirm')}}</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.fileUp input {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;/*关键点*/
  filter: alpha(opacity=0);/*兼容ie*/
  font-size: 20px;/* 增大不同浏览器的可点击区域 */
  cursor: pointer;
}
</style>
<script>
import i18nService from "@/core/services/i18n.service";
export default {
  data() {
    return {
      mainConfigList: [],
      configList: [],
      configId: "",
      deliveryTime: "",
      pnlLength:"",
      pnlWidth:"",
      quantity:"",
      orderDeailArea:"",
      materialType:"",
      materialList:[],
      manufacturerList:[],
      currDate: "",
      estimateDate: "",
      craftTwo:"",
      processFee:0,
      setUpPrice:{},
      setUpList:[],
      materiaDatalList:[],
      brand:'',
      exchangeRate:null,
      exchangeType:null,
      exchangeDate:null,
      avgPrice:null,
      price:null,
      amount:null,
      largePlatesNumber:0,
      level:null,
      product:{},
      temp:0,
      currencyTypeList:[],
      pnlDivisor:"",
      materiaDatalListStr:[],
      currencyType:null,
      unitLength:null,
      unitWidth:null,
      materialFee:0,
      rate:0,
      rateSubtotal:0,
      orderAgreementList:[],
      orderNowFlag:false,
      useRatio:null,
      fileList:[],
      recordId: "",
      managePrecent:null,
    };
  },
  computed: {
    user: {
      get () {
        return this.$store.getters.currentUser;
      }
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  },
  mounted() {
    this.product = eval('(' + window.localStorage.getItem('order') + ')');
    if(this.product && this.product.recordId)
    {
      window.localStorage.removeItem('order');
    }
    this.initData();
    this.getMaterialBond();
  },
  methods: {
    getColWidth(rowFlag) {
      // 获取列长度
      if (rowFlag == 1) {
        return "col-xl-12";
      } else if (rowFlag == 2) {
        return "col-xl-6";
      } else if (rowFlag == 3) {
        return "col-xl-4";
      } else if (rowFlag == 4) {
        return "col-xl-8";
      }
      return "col-xl-12";
    },
    initData() {
      // 获取产品列表
      this.setUpdateData();
      this.getMainConfigList();
    },
    getMaterialBond:function (){
      // 获取结算方式
      const query = {};
      query.defaultDb = this.user.defaultDb;
      query.groupManageId = this.user.groupManageId;
      query.userId = this.user.recordId;
      const _this = this;
      this.$axios.fetchPost("is/offer/getMaterialBond", query).then(result => {
        _this.currencyTypeList = result.data.currencyTypeList;
        if(_this.currencyTypeList && _this.currencyTypeList.length > 0 && !_this.currencyType)
        {
          // 默认人民币
          for(let currencyType of _this.currencyTypeList)
          {
            if(currencyType.value == "RMB")
            {
              _this.currencyType = currencyType.recordId;
              break;
            }
          }
        }
      }).catch(err => {alert(err)});
    },
    setUpdateData(){
      if(this.product)
      {
        // 编辑订单，进行赋值
        this.recordId = this.product.recordId;
        this.configId = this.product.configId;
        this.deliveryTime = this.product.deliveryTime;
        this.unitLength = this.product.unitLength;
        this.unitWidth = this.product.unitWidth;
        this.pnlLength = this.product.pnlLength;
        this.pnlWidth = this.product.pnlWidth;
        this.pnlDivisor = this.product.pnlDivisor;
        this.quantity = this.product.quantity;
        this.orderDeailArea = this.product.orderDeailArea;
        this.materialType = this.product.materialType;
        this.currDate = this.product.createdDate;
        this.estimateDate = this.product.deliveryDateStr;
        this.brand = this.product.brand;
        this.exchangeRate = this.product.exchangeRate;
        this.exchangeType = this.product.exchangeType;
        this.exchangeDate = this.product.exchangeDate;
        this.price = this.product.price;
        this.amount = this.product.subTotal;
        this.currencyType = this.product.currencyType;
        this.fileList = [];
        if (this.product.attaList){
          this.fileList = this.product.attaList;
        }
        // 明细赋值
        const _this = this;
        if (this.configList && this.configList.length > 0) {
          _this.setUpdateDetailData();
        } else {
          if (this.temp > 50) {
            _this.temp = 0;
            return;
          }
          _this.temp++;
          setTimeout(function () { _this.setUpdateData() }, 500);
        }
      }
    },
    setUpdateDetailData: function () {
      // 编辑状态下明细赋值
      for (let i=0;i<this.configList.length;i++){
        const config = this.configList[i];
        if (config.list){
          for (let k=0;k<config.list.length;k++){
            const deail = config.list[k];
            deail.value = "";
            deail.value1 = "";
            deail.value2 = "";
            deail.value3 = "";
            for (let j=0;j<this.product.deailList.length;j++){
              if (this.product.deailList[j].configDeailId == deail.recordId){
                if (deail.inputType == 1){
                  deail.value = this.product.deailList[j].value;
                }else if (deail.inputType == 2){
                  deail.value1 = this.product.deailList[j].value1;
                  deail.value2 = this.product.deailList[j].value2;
                }else if (deail.inputType == 3){
                  deail.value1 = this.product.deailList[j].value1;
                  deail.value2 = this.product.deailList[j].value2;
                  deail.value3 = this.product.deailList[j].value3;
                }else if (deail.inputType == 4){
                  if (this.product.deailList[j].value && deail.list){
                    for (let z = 0; z < deail.list.length; z++) {
                      if (deail.list[z].recordId == this.product.deailList[j].value){
                        this.$set(deail.list[z], "checked", 1);
                        deail.checked = 1;
                        this.disableInput(deail.list[z],deail,config.list,config);
                        break;
                      }
                    }
                  }
                }else if (deail.inputType == 5){
                  if (this.product.deailList[j].value){
                    const vals = this.product.deailList[j].value.split(",");
                    for (let x=0;x<vals.length;x++){
                      for (let z = 0; z < deail.list.length; z++) {
                        if (deail.list[z].recordId == vals[x]){
                          this.$set(deail.list[z], "checked", 1);
                          deail.checked = 1;
                          this.disableInput(deail.list[z],deail,config.list,config);
                        }
                      }
                    }
                  }
                }else if (deail.inputType == 6){
                  deail.attachMents = this.product.deailList[j].attachMents;
                }else if (deail.inputType == 7){
                  deail.value = this.product.deailList[j].value;
                }
                break;
              }
            }
          }
        }
      }
      this.product = {};
    },
    getMainConfigList() {
      // 获取所有配置单据页面
      this.configId = "";
      const config = {};
      config.defaultDb = this.user.defaultDb;
      config.groupManageId = this.user.groupManageId;
      config.userId = this.user.recordId;
      config.type = 1;
      const _this = this;
      this.$axios.fetchPost("is/offer/getMainConfigList", config).then(result => {
        // 获取产品配置
        _this.mainConfigList = result.data;
        if (_this.mainConfigList && _this.mainConfigList.length > 0){
          if(_this.activeLanguage && _this.activeLanguage == 'en')
          {
            for(let main of _this.mainConfigList)
            {
              if(main.enName)
              {
                main.name = main.enName;
              }
            }
          }

          if(!_this.configId)
          {
            _this.configId = _this.mainConfigList[0].recordId;
          }
          _this.getConfigList(_this.configId);
        }else{
          alert(this.$t('CONTENT.Product'));
        }
      }).catch(err => {alert(err)});
    },
    getConfigList(id) {
      // 按单据配置id获取单据明细
      if (!id){
        return;
      }
      this.configId = id;
      // 产品设置
      for (let i = 0; i < this.mainConfigList.length; i++) {
        if (this.mainConfigList[i].recordId == id) {
          this.$set(this.mainConfigList[i], "checked", 1);
          this.level = this.mainConfigList[i].level;
        }else{
          this.$set(this.mainConfigList[i], "checked", 0);
        }
      }
      const config = {};
      config.defaultDb = this.user.defaultDb;
      config.groupManageId = this.user.groupManageId;
      config.userId = this.user.recordId;
      config.configId = id;
      const _this = this;
      this.$axios.fetchPost("is/offer/getConfigList", config).then(result => {
        // 获取产品配置
        _this.configList = result.data;
        if(_this.activeLanguage && _this.activeLanguage == 'en' && _this.configList && _this.configList.length > 0)
        {
          for(let config of _this.configList)
          {
            if(config.enName)
            {
              config.name = config.enName;
            }
            if(config.list && config.list.length > 0)
            {
              for(let one of config.list)
              {
                if(one.enName)
                {
                  one.name = one.enName;
                }
                if(one.list && one.list.length > 0)
                {
                  for(let two of one.list)
                  {
                    if(two.enName)
                    {
                      two.value = two.enName;
                    }
                  }
                }
              }
            }
          }
        }
        _this.hiddenData(1);
      }).catch(err => {alert(err)});
    },
    selectType(craft, row,list,item) {
      // 设置选中项
      for (let i = 0; i < row.list.length; i++) {
        if (row.inputType == 5) {
          if(row.list[i].recordId == craft.recordId){
            if(!row.list[i].checked || row.list[i].checked === ''){
              this.$set(row.list[i], "checked", 1);
            }else if (row.list[i].checked === 1) {
              this.$set(row.list[i], "checked", '');
            }
            this.disableInput(row.list[i],row,list,item);
          }
        }else if (row.inputType == 4){
          if (row.list[i].recordId == craft.recordId) {
            if(!row.list[i].checked || row.list[i].checked == '')
            {
              this.$set(row.list[i], "checked", 1);
              row.checked = 1;
            }
            else
            {
              this.$set(row.list[i], "checked", '');
              row.checked = '';
            }
            this.disableInput(row.list[i],row,list,item);
          }else{
            this.$set(row.list[i], "checked", '');
          }
        }
      }
    },
    disableInput(craft,row,list,item){
      if(!craft)
      {
        return;
      }
      let flag = false;
      if(craft.checked && craft.checked == 1)
      {
        flag = true;
      }
      if(craft.itemId && craft.itemId == 1)
      {
        // 有数据字典
        this.orderNowFlag = false;
        if(!(craft.value == '单面' || craft.value == 'Single side'))
        {
          // 除了 单面 的都直接保存下单，不报价，不回交期
          this.orderNowFlag = true;
        }
      }
      // 获取当前选择的项是否有控制其它组件
      let controlsFlag = false;
      for(let config of this.configList)
      {
        // 直接获取判断
        if(config.remark == craft.sourceId)
        {
          controlsFlag = true;
          break;
        }
        // 数据字典判断
        if(config.list && config.list.length > 0)
        {
          for(let obj of config.list)
          {
            if(obj.disableFlag && obj.disableFlag == 3)
            {
              if(obj.remark == craft.sourceId)
              {
                controlsFlag = true;
                break;
              }
            }
          }
        }
      }
      if(controlsFlag)
      {
        let num = null;
        if(item.disableFlag && item.disableFlag == 3)
        {
          num = 2;
        }
        else
        {
          num = 1;
        }
        this.hiddenData(num,flag);
        this.showData(craft,flag);
      }
    },
    // 隐藏 清除值
    hiddenData(num,flag)
    {
      for(let config of this.configList)
      {
        if(num == 1)
        {
          if(config.disableFlag && config.disableFlag == 3)
          {
            config.selectFlag = false;
          }
        }
        if(config.list && config.list.length > 0)
        {
          // 清除选择项
          for(let obj of config.list)
          {
            // 隐藏
            if(obj.disableFlag && obj.disableFlag == 3)
            {
              obj.selectFlag = false;
              if(obj.list && obj.list.length > 0)
              {
                for(let i = 0;i<obj.list.length;i++)
                {
                  // 清空选择
                  this.$set(obj.list[i], "checked", '');
                }
              }
            }
            else
            {
              if(num == 1 && !flag)
              {
                // 清空选择
                if(obj.list && obj.list.length > 0)
                {
                  for(let i = 0;i<obj.list.length;i++)
                  {
                    this.$set(obj.list[i], "checked", '');
                  }
                }
              }
            }
          }
        }
      }
    },
    showData(craft,flag)
    {
      for(let config of this.configList)
      {
        if(config.disableFlag && config.disableFlag == 3)
        {
          if(config.remark == craft.sourceId)
          {
            config.selectFlag = flag;
          }
        }
        if(config.list && config.list.length > 0)
        {
          // 清除选择项
          for(let obj of config.list)
          {
            if(obj.disableFlag && obj.disableFlag == 3)
            {
              if(obj.remark == craft.sourceId)
              {
                obj.selectFlag = flag;
              }
            }
          }
        }
      }
    },
    // 计算交期
    getDeliveryTime()
    {
      const numPattern = /^\d*\.?\d+$/;
      if ((this.unitLength && (!numPattern.test(this.unitLength) || parseFloat(this.unitLength) <= 0 || parseFloat(this.unitLength) === 0)) ||
          (this.unitWidth && (!numPattern.test(this.unitWidth) || parseFloat(this.unitWidth) <= 0 || parseFloat(this.unitWidth) === 0)) ||
          (this.pnlLength && (!numPattern.test(this.pnlLength) || parseFloat(this.pnlLength) <= 0 || parseFloat(this.pnlLength) === 0)) ||
          (this.pnlWidth && (!numPattern.test(this.pnlWidth) || parseFloat(this.pnlWidth) <= 0 || parseFloat(this.pnlWidth) === 0)) ||
          (this.pnlDivisor && (isNaN(this.pnlDivisor) || parseFloat(this.pnlDivisor) < 0 || /[a-zA-Z!@#$%^&*(),.?":{}|<>]/.test(this.pnlDivisor) || parseFloat(this.pnlDivisor) === 0)) ||
          (this.quantity && (isNaN(this.quantity) || parseFloat(this.quantity) < 0 || /[a-zA-Z!@#$%^&*(),.?":{}|<>]/.test(this.quantity) || parseFloat(this.quantity) === 0))) {
        // 变量不满足要求
        alert(this.$t('ONLINE.Please_enter_a_number_that_cannot_be_less_than_zero'));
        return;
      }
      if((!(this.unitLength && this.unitWidth) && !(this.pnlLength && this.pnlWidth && this.pnlDivisor)) || !this.quantity || !this.materialType)
      {
        return;
      }
      const date = new Date();
      this.estimateDate = "";
      this.deliveryTime = null;
      // 计算订单面积
      if(!this.pnlLength || !this.pnlWidth || !this.pnlDivisor)
      {
        const unitWidth = this.unitWidth;
        const unitLength = this.unitLength;
        this.orderDeailArea = Number((this.quantity * unitWidth * unitLength / 1000000).toFixed(2));
      }else{
        const length = this.pnlLength;
        const width = this.pnlWidth;
        const pnlDivisor = this.pnlDivisor;
        // 计算订单面积
        this.orderDeailArea = Number((this.quantity * length * width / pnlDivisor / 1000000).toFixed(2));
      }
      if(this.orderDeailArea && this.orderDeailArea <= 0.1)
      {
        this.deliveryTime = 3;
      }else {
        if (this.materialType == 2)
        {
          this.deliveryTime = 11;
          if (this.orderDeailArea > 100)
          {
            const day = Math.ceil(this.orderDeailArea / 100) - 1;
            this.deliveryTime += day;
          }
        }
        else if (this.materialType == 3)
        {
          this.deliveryTime = 8;
          if (this.orderDeailArea > 100)
          {
            const day = Math.ceil(this.orderDeailArea / 100) - 1;
            this.deliveryTime += day;
          }
        }
      }
      // 交期
      this.estimateDate = this.addDay(date, this.deliveryTime);
      // 下单时间
      this.currDate = this.addDay(date, 0);
    },
    addDay: function(oldtime, days) {
      const fd = new Date(oldtime.valueOf() + days * 24 * 60 * 60 * 1000); // 日期加上指定的天数
      let newtime = fd.getFullYear() + "-";
      const month = fd.getMonth() + 1;
      if (month >= 10) {
        newtime += month + "-";
      } else {
        // 在小于10的月份上补0
        newtime += "0" + month + "-";
      }
      if (fd.getDate() >= 10) {
        newtime += fd.getDate();
      } else {
        // 在小于10的日期上补0
        newtime += "0" + fd.getDate();
      }
      return newtime;
    },
    // 加载汇率
    loadExchangeRate(){
      const entity = {};
      entity.defaultDb = this.user.defaultDb;
      entity.groupManageId = this.user.groupManageId;
      entity.userId = this.user.recordId;
      entity.currencyType = this.currencyType;
      const _this = this;
      this.$axios.fetchPost("is/offer/getExchangeRate", entity).then(result => {
        _this.exchangeRate = result.data.rate;
        _this.exchangeType = result.data.currencyType;
        _this.exchangeDate = result.data.orderDate;
        _this.computAmount();
      }).catch(err => {alert(err)});
    },
    // 选择品牌
    selectBond(brand){
      this.avgPrice = 0;
      this.brand = brand;
      this.craftTwo = 1;
      this.getMaterialData();
    },
    // 获取材料价格
    getMaterialData(){
      const interProduct = {};
      interProduct.deailList = this.getSelectList();
      interProduct.defaultDb = this.user.defaultDb;
      interProduct.groupManageId = this.user.groupManageId;
      interProduct.userId = this.user.recordId;
      interProduct.pnlLength = this.pnlLength;
      interProduct.pnlWidth = this.pnlWidth;
      interProduct.quantity = this.quantity;
      interProduct.orderDeailArea = this.orderDeailArea;
      interProduct.materialType = this.materialType;
      interProduct.brand = this.brand;
      const _this = this;
      this.avgPrice = 0;
      this.$axios.fetchPost("is/offer/getMaterialData", interProduct).then(result => {
        _this.materiaDatalList = result.data.materialList;
        if(_this.materiaDatalList && _this.materiaDatalList.length > 0)
        {
          this.avgPrice = _this.materiaDatalList[0].avgPrice;
        }
        _this.computAmount();
      }).catch(err => {alert(err)});
    },
    computAmount(){
      let materialFee = 0;
      let area = 0;
      if(this.pnlLength && this.pnlWidth && this.pnlDivisor){
        area = Number((this.quantity * this.pnlLength * this.pnlWidth /this.pnlDivisor/1000000).toFixed(2));
      }else{
        area = this.unitWidth * this.unitLength * this.quantity/1000000;
      }

      // 材料费
      if(this.avgPrice && this.avgPrice > 0)
      {
        materialFee = Number((Number(area) * Number(this.avgPrice) / this.useRatio * 100).toFixed(2));
      }
      this.materialFee = materialFee;

      //加工费
      let processFee = 0
      if(this.processFee && this.processFee > 0)
      {
        processFee = Number(this.processFee);
      }
      // 货币类型后费用 = 材料费 + 加工费
      this.amount = materialFee + processFee;
      this.amount = (Number(this.amount) * this.managePrecent /100) + this.amount;
      // 样品与非样品费用计算
      this.price = 0;
      if(area && area > 0.1)
      {
        if(this.level)
        {
          // 默认客户等级为C级
          let rate = 0;
          switch (this.level)
          {
            case "1":
              rate = 0.3;
              break;
            case "2":
              rate = 0.2;
              break;
            case "3":
              rate = 0.15;
              break;
            case "4":
              rate = 0.1;
              break;
          }
          this.rate = rate * 100;
          this.rateSubtotal = this.amount * rate;
          this.amount = (this.amount + this.rateSubtotal).toFixed(2);
        }
        this.price = (this.amount / this.quantity).toFixed(4);
      }
      else
      {
        if(this.amount < 150)
        {
          this.amount = 150;
        }
        else
        {
          this.amount = this.amount * 1.5;
        }
      }
    },
    getQuotationSetUp(){
      const interProduct = {};
      interProduct.deailList = this.getSelectList();
      interProduct.defaultDb = this.user.defaultDb;
      interProduct.groupManageId = this.user.groupManageId;
      interProduct.userId = this.user.recordId;
      interProduct.pnlLength = this.pnlLength;
      interProduct.pnlWidth = this.pnlWidth;
      interProduct.quantity = this.quantity;
      interProduct.orderDeailArea = this.orderDeailArea;
      interProduct.materialType = this.materialType;
      interProduct.useRatio = this.useRatio;
      for(let deail of interProduct.deailList){
        if(deail.name == '沉头孔个数')
        {
          interProduct.countersinkHole = deail.value ? Number(deail.value) : 0;
          break;
        }
      }
      const _this = this;
      this.$axios.fetchPost("is/offer/getQuotationSetUpData", interProduct).then(result => {
        _this.setUpPrice.setUpAreaPrice = result.data.setUpAreaPrice;
        _this.setUpPrice.setUpPcsPrice = result.data.setUpPcsPrice;
        _this.setUpPrice.setUpHolePrice = result.data.setUpHolePrice;
        _this.setUpPrice.setUpFixedFee = result.data.setUpFixedFee;
        _this.setUpList = result.data.setUpList;
        if (_this.setUpList && _this.setUpList.length > 0){
          let orderDeailArea = interProduct.orderDeailArea?Number(interProduct.orderDeailArea):0;
          let quantity = interProduct.quantity?Number(interProduct.quantity):0;
          let countersinkHole = interProduct.countersinkHole;
          for (let i=0;i<_this.setUpList.length;i++){
            if (_this.setUpList[i] && _this.setUpList[i].list && _this.setUpList[i].list.length > 0){
              for (let j=0;j<_this.setUpList[i].list.length;j++){
                let countPrice = _this.setUpList[i].list[j].price?Number(_this.setUpList[i].list[j].price):0;
                if (_this.setUpList[i].countMethod == 1){
                  _this.setUpList[i].list[j].countMoney = _this.formatMoney((countPrice * orderDeailArea).toFixed("4"));
                }else if (_this.setUpList[i].countMethod == 2){
                  _this.setUpList[i].list[j].countMoney = _this.formatMoney((countPrice * quantity).toFixed("4"));
                }else if (_this.setUpList[i].countMethod == 3){
                  _this.setUpList[i].list[j].countMoney = _this.formatMoney((countPrice * countersinkHole).toFixed("4"));
                }else {
                  _this.setUpList[i].list[j].countMoney = _this.formatMoney(countPrice.toFixed("4"));
                }
              }
            }
          }
        }
        _this.coutExcutePrice(interProduct);
      }).catch(err => {alert(err)});
    },
    coutExcutePrice(interProduct){
      this.processFee = (
          Number(this.setUpPrice.setUpAreaPrice == null?0:this.setUpPrice.setUpAreaPrice) *
          Number(interProduct.orderDeailArea == null ? 0 : interProduct.orderDeailArea) +
          Number(this.setUpPrice.setUpHolePrice?0:this.setUpPrice.setUpHolePrice) *
          Number(interProduct.countersinkHole == null ? 0 : interProduct.countersinkHole) +
          Number(this.setUpPrice.setUpPcsPrice?0:this.setUpPrice.setUpPcsPrice) *
          Number(interProduct.quantity == null ? 0 : interProduct.quantity
              + Number(this.setUpPrice.setUpFixedFee?0:this.setUpPrice.setUpFixedFee)
          )
      ).toFixed("4");
      this.computAmount();
    },
    formatMoney(s){
      if (!isNaN(s)) {
        var noNegative = true; // 默认是正值。
        s = parseFloat(s + "").toFixed(2);
        s = s + ""; // 转换成字符串
        if (parseFloat(s) < 0) {
          // 是负数
          s = Math.abs(s).toFixed(2) + "";
          noNegative = false;
        }
        var zheng = s.split(".")[0];
        var dian = s.split(".")[1];
        // 将整数部分，利用字符串的charAt() 方法，转换成数组。
        var zhengArr = [];
        for (var i = 0; i < zheng.length; i++) {
          zhengArr.push(zheng.charAt(i));
        }
        zhengArr = zhengArr.reverse();
        var t = "";
        for (let i = 0; i < zhengArr.length; i++) {
          if (i % 3 === 2 && i !== zhengArr.length - 1) {
            // 为第三位，并且并不是最后了。如123456时，6并不加,
            t += zhengArr[i] + ",";
          } else {
            t += zhengArr[i] + ""; // 加上空格
          }
        }
        return ((noNegative ? "" : "-") + t.split("").reverse().join("") + "." + dian);
      }
      return 0;
    },
    // 订单验证
    craftValite() {
      if (!(this.configId && this.unitLength && this.unitWidth && this.pnlLength && this.pnlWidth && this.pnlDivisor
          && this.quantity && this.materialType && this.currencyType)){
        return this.$t('CONTENT.REDMSG');
      }
    },
    // 评估下单
    getBrandList(){
      // 开始报价
      const message = this.craftValite();
      if (message){
        alert(message);
        return;
      }
      this.craftTwo = "";
      this.brand = null;

      const interProduct = {};
      interProduct.deailList = this.getSelectList();
      interProduct.defaultDb = this.user.defaultDb;
      interProduct.groupManageId = this.user.groupManageId;
      interProduct.userId = this.user.recordId;
      const _this = this;
      this.$axios.fetchPost("is/offer/getMaterialDaterStr", interProduct).then(result => {
        _this.materiaDatalListStr = result.data.orgList;
        _this.managePrecent = result.data.managePrecent;
        if (result.data.useRatio){
          _this.useRatio = result.data.useRatio;
        }else {
          _this.useRatio = 89;
        }
        if( _this.materiaDatalListStr && _this.materiaDatalListStr.length > 0)
        {
          for(let mat of _this.materiaDatalListStr)
          {
            if(_this.activeLanguage && _this.activeLanguage == 'en' && mat.enName)
            {
              mat.showValue = mat.enName;
            }
            else
            {
              mat.showValue = mat.value;
            }
          }
          let value = null;
          switch (this.level)
          {
              // B类
            case "2":
              value = "航宇";
              break;
              // C类
            case "3":
              value = "星元";
              break;
          }
          if(!value)
          {
            value = _this.materiaDatalListStr[0].value;
          }
          if(value)
          {
            _this.selectBond(value);
          }
        }
        _this.getQuotationSetUp();
        this.$refs['tipWindow'].show();
      }).catch(err => {alert(err)});
    },
    // 保存订单
    saveDeail(type) {
      const message = this.craftValite();
      if (message){
        alert(message);
        return;
      }
      this.getDeliveryTime();
      const entity = {};
      if (this.recordId) {
        entity.recordId = this.recordId;
      }
      entity.deailList = this.getSelectList();
      entity.type = 1;
      entity.status = 1;
      entity.defaultDb = this.user.defaultDb;
      entity.groupManageId = this.user.groupManageId;
      entity.userId = this.user.recordId;
      entity.configId = this.configId;
      entity.pnlLength = this.pnlLength;
      entity.pnlWidth = this.pnlWidth;
      entity.quantity = this.quantity;
      if (!this.pnlWidth|| !this.pnlWidth || !this.pnlDivisor){
        entity.orderDeailArea = (this.quantity * this.unitWidth * this.unitLength / 1000000).toFixed(2);
      }else{
        entity.orderDeailArea = (this.quantity * this.pnlLength * this.pnlWidth / this.pnlDivisor/1000000).toFixed(2);
      }
      entity.currencyType = this.currencyType;
      entity.deliveryTime = this.deliveryTime;
      entity.materialType = this.materialType;
      entity.status = 1
      entity.deliveryDate = this.estimateDate;
      entity.brand = this.brand;
      entity.exchangeRate = this.exchangeRate;
      entity.exchangeType = this.exchangeType;
      entity.exchangeDate = this.exchangeDate;
      entity.price = this.price;
      entity.subTotal = this.amount;
      entity.pnlDivisor = this.pnlDivisor;
      entity.unitLength = this.unitLength;
      entity.unitWidth = this.unitWidth;
      const param = new FormData()
      param.append('entity', JSON.stringify(entity))
      if (this.fileList && this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          if (!this.fileList[i].downloadUrl) {
            param.append('files', this.fileList[i])
          }
        }
      }
      if (type == 0 && this.fileList && this.fileList.length == 0) {
        return this.$refs['fileMessage'].show();
      }
      if(entity.materialType == "" || entity.materialType == null)
      {
        return alert(this.$t('CONTENT.SELECT_ORDER_TYPE'));
      }
      if(!entity.quantity)
      {
        return alert(this.$t('CONTENT.Quantity'));
      }
      if(entity.orderDeailArea > 0.1 && entity.materialType == 1)
      {
        return alert(this.$t('CONTENT.Sample_Prompt'));
      }
      if(!entity.currencyType)
      {
        return alert(this.$t('ONLINE.Please_select_a_currency_type'));
      }
      const _this = this;
      this.$axios.formPost("is/offer/saveProduct", param).then(result => {
        if (result.data && result.data == "success"){
          _this.$router.push("/");
          this.$refs['fileMessage'].hide();
        }else {
          alert(this.$t('ONLINE.Please_refresh_and_retry'));
        }
      }).catch(err => {alert(err)});
    },
    // 获取配置表录入值
    getSelectList(){
      const list = [];
      if (this.configList && this.configList.length > 0){
        for (let i=0;i<this.configList.length;i++){
          const config = this.configList[i];
          if (config && config.list && config.list.length > 0){
            for (let j=0;j<config.list.length;j++){
              const row = config.list[j];
              const deail = {};
              deail.configId = config.recordId;
              deail.configDeailId = row.recordId;
              deail.value = "";
              deail.value1 = "";
              deail.value2 = "";
              deail.value3 = "";
              deail.name = row.name;
              deail.inputType = row.inputType;
              if (row.inputType == 1){
                if (config.list[j].value){
                  deail.value = config.list[j].value;
                }
                list.push(deail);
              }else if (row.inputType == 2){
                if (config.list[j].value1){
                  deail.value1 = config.list[j].value1;
                }
                if (config.list[j].value2){
                  deail.value2 = config.list[j].value2;
                }
                list.push(deail);
              }else if (row.inputType == 3){
                if (config.list[j].value1){
                  deail.value1 = config.list[j].value1;
                }
                if (config.list[j].value2){
                  deail.value2 = config.list[j].value2;
                }
                if (config.list[j].value3){
                  deail.value3 = config.list[j].value3;
                }
                list.push(deail);
              }else if (row.inputType == 4){
                if(row.list){
                  for (let k = 0; k < row.list.length; k++) {
                    if (row.list[k].checked && row.list[k].checked == 1){
                      deail.value = row.list[k].recordId;
                      deail.itemId = row.list[k].itemId;
                      deail.sourceId = row.list[k].sourceId;
                      deail.sourceValue = row.list[k].value;
                      break;
                    }
                  }
                }
                list.push(deail);
              }else if (row.inputType == 5){
                if(row.list) {
                  for (let k = 0; k < row.list.length; k++) {
                    if (row.list[k].checked && row.list[k].checked == 1) {
                      if (deail.value) {
                        deail.value = deail.value + ',' + row.list[k].recordId;
                      } else {
                        deail.value = row.list[k].recordId;
                      }
                      deail.itemId = row.list[k].itemId;
                      deail.sourceId = row.list[k].sourceId;
                      deail.sourceValue = row.list[k].value;
                    }
                  }
                }
                list.push(deail);
              }else if (row.inputType == 6){
                list.push(deail);
              }else if (row.inputType == 7){
                if (config.list[j].value){
                  deail.value = config.list[j].value;
                }
                list.push(deail);
              }
            }
          }
        }
      }
      return list;
    },
    // 获取下单说明
    showOrderAgreement(){
      const _this = this;
      this.$axios.fetchPost("is/offer/getOrderAgreementList", this.user).then(result => {
        _this.orderAgreementList = result.data;
        this.$refs['orderAgreementOpen'].show();
      }).catch(err => {alert(err)});
    },
    // 上传文件
    uploadMaterials(file){
      if (file.target.files && file.target.files.length > 0) {
        for (let x = 0; x < file.target.files.length; x++) {
          const f = file.target.files[x]
          const type = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']
          if (f && (type.indexOf(f.type) >= 0 || !f.type)) {
            for (const i in this.fileList) {
              if (this.fileList[i].name === f.name) {
                alert('文件“' + f.name + '”已经存在！')
                return
              }
            }
            this.fileList.push(f)
          } else {
            alert('只能上传jpg/jpeg/png/pdf/doc/docx/xls/xlsx/ppt/pptx后缀名的文件')
          }
        }
      }
    },
    delAttachment: function (index) {
      if (this.fileList[index] && this.fileList[index].downloadUrl) {
        // 删除后台关联及存储
        this.$axios.fetchPost('is/offer/delAttachment', this.fileList[index]).then((data) => {
          if (data.data) {
            if (data.data === 'success') {
              alert(this.$t('ONLINE.Successfully_deleted'));
              this.fileList.splice(index, 1)
            } else {
              alert(this.$t('ONLINE.System_error'));
            }
          }
        }).catch(err => {
              console.log(err)
            }
        )
      } else {
        this.fileList.splice(index, 1)
      }
    },
    preview(item,downloadUrl){
      const _this = this;
      if (document.getElementById('preview')) {
        document.getElementById('preview').src = downloadUrl;
      } else {
        if (_this.temp > 50) {
          _this.temp = 0;
          return;
        }
        _this.temp++;
        setTimeout(function () { _this.showPreview(item) }, 500);
      }
    },
    showPreview: function (item) {
      const file = item
      const type = ['image/jpg', 'image/jpeg', 'image/png']
      const typePdf = ['application/pdf']
      const _this = this;
      if (file && type.indexOf(file.type) >= 0) {
        if (item.downloadUrl) {
          _this.$refs.previewId.show();
          _this.preview(item,item.downloadUrl);
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            _this.$refs.previewId.show();
            _this.preview(item,reader.result);
          }
        }
      } else if (file && typePdf.indexOf(file.type) >= 0) {
        if (item.downloadUrl) {
          const win = window.open()
          win.document.write('<body style="margin:0px;"><iframe src="' + item.downloadUrl + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
          win.document.close()
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            const win = window.open()
            win.document.write('<body style="margin:0px;"><iframe src="' + reader.result + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
            win.document.close()
          }
        }
      } else {
        if (item.downloadUrl) {
          if (file.type) {
            const win = window.open()
            win.document.write('<body style="margin:0px;"><iframe src="https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(item.downloadUrl) + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
            win.document.close()
          } else {
            const strs = item.name.split('.')
            if (strs[1] === 'jpg' || strs[1] === 'JPG' || strs[1] === 'png' || strs[1] === 'PNG' || strs[1] === 'jpeg' ||
                strs[1] === 'JPEG' || strs[1] === 'bmp' || strs[1] === 'BMP' || strs[1] === 'gif' || strs[1] === 'GIF') {
              this.$refs.previewId.show();
              document.getElementById('preview').src = item.downloadUrl
            } else if (strs[1] === 'docx' || strs[1] === 'DOCX' || strs[1] === 'doc' || strs[1] === 'DOC' || strs[1] === 'xls' ||
                strs[1] === 'XLS' || strs[1] === 'xlsx' || strs[1] === 'XLSX') {
              const win = window.open()
              win.document.write('<body style="margin:0px;"><iframe src="https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(item.downloadUrl) + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
              win.document.close()
            } else if (strs[1] === 'pdf' || strs[1] === 'PDF') {
              const win = window.open()
              win.document.write('<body style="margin:0px;"><iframe src="' + item.downloadUrl + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
              win.document.close()
            }
          }
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            const win = window.open()
            win.document.write('<body style="margin:0px;"><iframe src="' + reader.result + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
            win.document.close()
          }
        }
      }
    },
    closeFile(){
      this.$refs['fileMessage'].hide();
    }
  }
}
</script>
